import { Container, Row, Col } from 'react-bootstrap'
import "./blog.css"
import "../../styles/style.css";
const Blog = () => {

    return (<>
        <section>
            <div className='about-page-background'>
                <Container>
                    <Row className='text-background'>
                        <Col md={5} >
                            <h3 className='about-me-text'>Page under construction</h3>
        </Col>
    </Row>
</Container>
</div >
        </section>

    </>);
}

export default Blog